/** Field errors from an API response, keyed by field name. */
export type ApiFieldErrors = Record<string, Array<string>>;

/** Converts errors in API response format to format expected by Mantine React Table. */
export function convertApiErrorsToMrtErrors(apiErrors: ApiFieldErrors) {
  return Object.entries(apiErrors).reduce((errors, [key, value]) => {
    if (key !== "non_field_errors") errors[key] = value[0];
    return errors;
  }, {});
}
